import NoteTagFormContainer from './NoteTagFormContainer';

export default NoteTagFormContainer;
